import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useSuspenseQuery } from '@tanstack/react-query'
import isOnline from 'is-online'
import React, { Suspense } from 'react'
import { useNetworkState } from 'react-use'

import { faExclamationTriangle } from '@/lib/fontAwesomePro/regular'
import { QUERY_KEYS } from '@/lib/queryKeys'

const NetworkStatusBarContent: React.FC = () => {
  const networkState = useNetworkState()

  const isOnlineQuery = useSuspenseQuery({
    // Use networkState.online as a query key so that when the navigator.onLine
    // property changes (navigator.onLine is used under the hood by networkState.online),
    // we can re-run the isOnline() query to determine the actual online status.
    // navigator.onLine cannot be relied upon to determine the online status.
    queryKey: QUERY_KEYS.isOnline(!!networkState.online),
    queryFn: () => isOnline(),
  })

  const isNetworkOnline = isOnlineQuery.data

  if (isNetworkOnline) {
    return null
  }

  return (
    <aside
      className="bg-destructive z-network-status-bar fixed right-0 bottom-0
        left-0 w-full p-4 text-white"
    >
      <div className="flex items-start justify-start gap-3 sm:justify-center">
        <FontAwesomeIcon
          icon={faExclamationTriangle}
          className="mt-0.5 text-lg"
        />
        You are not connected to the internet. Please check your connection.
      </div>
    </aside>
  )
}

const NetworkStatusBar: React.FC = () => (
  <Suspense fallback={null}>
    <NetworkStatusBarContent />
  </Suspense>
)

export default NetworkStatusBar
